export default "__VITE_ASSET__DpzcT2V4__"